<script>
export default {
  page: {
    title: 'Success',
    meta: [{ name: 'description', content: 'The Success page.' }],
  },
  components: {},
}
</script>

<template>
  <v-container fluid>
    <v-container :class="$style.innerContainer">
      <v-row
        no-gutters
        :class="$style.title"
        class="input--text"
        justify="center"
      >
        2FA Registration
      </v-row>
      <v-row
        no-gutters
        :class="$style.subtitle"
        class="input--text"
        justify="center"
      >
        Please check your email to complete verification
      </v-row>
      <v-row class="mt-11" no-gutters justify="end">
        <v-btn
          width="112"
          height="56"
          rounded
          color="primary"
          :class="$style.hrButton"
          class="my-auto text-capitalize"
          to="/login"
          >Log In</v-btn
        >
      </v-row>
    </v-container>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';
.innerContainer {
  max-width: 400px;
  margin-bottom: 250px;
}

.title {
  margin-bottom: 25px !important;
  font-size: 32px;
  font-weight: 400;
  line-height: 48px;
  letter-spacing: 1px;
}

.subtitle {
  margin-bottom: 25px !important;
  font-size: 13px;
  font-weight: 500;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0.25px;
}

.hrButton {
  font-size: 15px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.75px;
  border-radius: 12px !important;
}
</style>
